import Header from './components/Header'
import RoutesPath from './RoutesPath'
import Footer from './components/Footer'

function App(){
    return (
        <>
            <Header />
            <RoutesPath />
            <Footer />
        </>
    )
}
 
export default App